// Wait for document to initialize
$(document).ready(function() {
  // Register click handler on each block list item content area
  // Some block list items may have collapsable content, this is
  // the handler used to toggle the content
  $('.block-list__item__content').on('click', function() {
    // Make a reference to the text element of the block list item
    var $text = $(this).find('.block-list__item__content__text');

    // If the text is already fully shown
    if ($text.hasClass('block-list__item__content__text--more')) {
      // Then collapse the extra text
      $text.removeClass('block-list__item__content__text--more');
    } else {
      // If the full text is not shown, then expand it
      $text.addClass('block-list__item__content__text--more');
    }
  });
});


/*****************
 ** WEBPACK FOOTER
 ** ./source/js/block-list.js
 ** module id = 4
 ** module chunks = 0
 **/